export * from './equal-validator.directive'



// WEBPACK FOOTER //
// ./src/app/shared/validators/index.ts